// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"Jx","delete_item":"Kx","subscription_item":"Lx","subscription_item_img_wrapper":"Mx","subscription_item_info":"Nx","subscription_item_title":"Ox","subscription_item_edit":"Px","subscription_item_wrapper":"Qx","arrow":"Rx","subscription_item_category":"Sx","plus_button":"Tx","more_details":"Ux","old_price":"Vx","discount":"Wx"};
    if(module.hot) {
      // 1713809678035
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  